<div class="box-card" [style.background-color]="backgroundColor" [style.height.px]="componentHeightPx" [style.height.%]="componentHeightPercent"
[style.max-height.px]="componentMaxHeight" [style.overflow-x]="componentOverflowX" [style.overflow-y]="componentOverflowY">
    <ng-content></ng-content>
</div>

<div *ngIf="showExpander" class="box-card-expand-button" (click)="onExpanderClick()">
    <div class="box-card-expand-button-linel" [ngStyle]="componentButtonLStyle"></div>
    <div class="box-card-expand-button-liner" [ngStyle]="componentButtonRStyle"></div>
</div>